if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    // Events

    const eventsForm = document.getElementById('events-form');
    const eventsSet = document.querySelectorAll('.js-event');
    
    const eventsProperties = [];
    eventsSet.forEach(event => {
        eventsProperties.push(JSON.parse(event.dataset.filters));
    });

    const filterEvents = () => {
        const activeInputs = eventsForm.querySelectorAll('input[type="checkbox"]:checked');
        document.querySelectorAll("#past-events")[0].classList.remove("hidden");
        
        eventsSet.forEach((event, index) => {
            let isHidden = true;
            const properties = eventsProperties[index];
            
            if (activeInputs.length == 0) {
                event.classList.remove("hidden");
            } else {
                activeInputs.forEach((input, index) => {
                    const currentFilter = input.dataset.filter;
                    const currentProperty = input.value == "true" ? true : input.value == "false" ? false : input.value;
                    const isPast = input.dataset.filter == "upcoming" && input.value == "false";
                    if (isPast) {
                        document.querySelectorAll("#past-events")[0].classList.remove("hidden");
                    }else{
                        document.querySelectorAll("#past-events")[0].classList.add("hidden");
                    }
                    if (properties[currentFilter] == currentProperty) isHidden = false;
                    if (index + 1 == activeInputs.length && isHidden == true) {
                        event.classList.add("hidden");
                    } else {
                        event.classList.remove("hidden");
                    }
                });
            }
        });

    };

    if (eventsForm) {
        eventsForm.querySelectorAll('input[type="checkbox"]').forEach(input => {
            input.addEventListener("change", filterEvents);
        });
    
        eventsForm.addEventListener("reset", () => {
            eventsSet.forEach(event => event.classList.remove("hidden"));
            document.querySelectorAll("#past-events")[0].classList.remove("hidden");
        });
    }

    function addTrackingParameters( htmlElement, trackingValue ){
        if( htmlElement ) {
            htmlElement.classList.add('custom_click_track');
            htmlElement.dataset.custom_click_track_value = trackingValue
        }
    }

    if( document.querySelector('form#email-signup button.signup-btn')){
        addTrackingParameters(document.querySelector('form#email-signup button.signup-btn'), "Footer: |Email Sign Up Click|internal|event462");
    }

    if(document.querySelector('footer .social-media .facebook')) {
        addTrackingParameters( document.querySelector('footer .social-media .facebook'), "Footer: Facebook|Social Site Click |external|event465")
    }

    if(document.querySelector('footer .social-media .instagram')) {
        addTrackingParameters( document.querySelector('footer .social-media .instagram'), "Footer: Instagram|Social Site Click |external|event465")
    }

    if(document.querySelector('.privary-navigation__item.primary-nav-4 a')) {
        addTrackingParameters( document.querySelector('.privary-navigation__item.primary-nav-4 a'), "NavBar Virtual Tour|Activity Link Click|external|event464")
    }

    if(document.querySelector('.privary-navigation__item a.js-tracking-meet-chef')) {
        addTrackingParameters( document.querySelector('.privary-navigation__item a.js-tracking-meet-chef'), "NavBar |Activity Link Click|internal|event464")
    }
    
    if(document.querySelector('form#form_id-1600 button.btn')) {
        addTrackingParameters( document.querySelector('form#form_id-1600 button.btn'), "Body: Cater your event|F&B RFP Click|internal|event460")
    }
    if(document.querySelector('form#form_id-1601 button.btn')) {
        addTrackingParameters( document.querySelector('form#form_id-1601 button.btn'), "Body: Let's chat|Contact Us Form Submit Click|internal|event461")
    }
    

    if(document.querySelector('form#form_id-1598 button.btn')) {
        addTrackingParameters( document.querySelector('form#form_id-1598 button.btn'), "Body: Gather at The Dorian|Meeting RFP Click|internal|event459")
    }

})();

 // Drag to discover image functionality
const dragContainer = document.querySelector('.discover-pic--js');

if( document.querySelector('.discover-pic--js') && dragContainer.querySelector('.discover-pic__range')){
    const range = dragContainer.querySelector('.discover-pic__range');
    
    function moveElements(v) {            
        const line = dragContainer.querySelector('.discover-pic__line');
        const firstImage = dragContainer.querySelectorAll('.discover-pic__item')[0];
        const secondImage = dragContainer.querySelectorAll('.discover-pic__item')[1];

        line.style.left = v + "%";
        firstImage.style.flexBasis = v + "%";
        secondImage.style.flexBasis = (100 - v) + "%";
    }

    range.addEventListener('input', () => {
        moveElements(range.value)
    });        
}

/** ADA  Disables keyboard navigation in menu links **/

document.addEventListener("DOMContentLoaded", () => {
    const mobileNavs = document.querySelectorAll(".primary-navigation__mobile, .secondary-navigation__item");

    if (mobileNavs.length > 0) {
        mobileNavs.forEach(nav => {
            const navLinks = nav.querySelectorAll("a");
            navLinks.forEach(link => link.setAttribute("tabindex", "-1"));
        });
    }
});
